import React, { Component } from 'react';
import { connect } from "react-redux";
import * as actionCreator from "../../../../action/index.js";
import { Checkbox } from '@rmwc/checkbox';
import DoorWindowTextTop from '../DoorWindowTextTop';
import DoorWindowTextBottom from '../DoorWindowTextBottom';
class RightDoorWindow extends Component {
  render() {
   let disVal = false;
   let SepdisVal = false;
   if(this.props.const_var.doorWallArrayValue[this.props.const_var.doorWall]=="Open" && this.props.params.add_storage_check_right==false)
   {
      if((this.props.const_var.doorWall=="Front" || this.props.const_var.doorWall=="Back" ) && this.props.params.add_storage_check_right==false)
      {
         disVal = true;
         SepdisVal = true;
      }
      if(this.props.const_var.doorWall=="FrontL" || this.props.const_var.doorWall=="BackL" )
      {
         disVal = true;
         SepdisVal = true;
      }
      if(this.props.const_var.doorWall=="FrontR" || this.props.const_var.doorWall=="BackR" )
      {
         disVal = true;
         SepdisVal = true;
      }
      if(this.props.const_var.doorWall=="Left" || this.props.const_var.doorWall=="Right" )
      {
         disVal = true;
         SepdisVal = false;
      }
      if(this.props.const_var.doorWall=="LeftL" || this.props.const_var.doorWall=="RightR" )
      {
         disVal = true;
         SepdisVal = false;
      }
   }
   var disableCls = {
    
       "pointer-events": "none"
     
   }
    return (
         <div>
   <div>
      <DoorWindowTextTop/>
   </div>
    <div className="section-seprator">
   {(this.props.params.add_storage_check==true || this.props.params.add_storage_check_right==true)?
     <div className="row">
      <div className="col-12  mb-2">
               
               {(this.props.params.add_storage_check_right==true)?
               <div className="checkbox">
                  <Checkbox 
                     className="secondary" 
                     ripple="RipplePropF" 
                     label="Right Storage"
                     checked={ this.props.params.rightstorage }
                     onChange={e => this.props.toggleActionForUtility('right') }
                  />
               </div>:null}
      </div>
   </div>:null
}
   <div className="door-window-items-wrapper mt-0 mb-0">
      <ul>
         <li className={ disVal==true ?"disabled":""}>
            <a onClick={e => this.props.addCustomComponent(this.props.const_var.garageInitialValue,'Garage','') }>
            <label>
            <span className="dw-icon">
            <span className="icon-roll-up-garage-door"></span>
            </span>
            <span className="dw-title">
            Garage Door
            </span>
            </label>
            <span className="dw-add-icon">
            <span className="icon-plus mr-1"></span>
            Add
            </span>
            </a>
         </li>
         <li className={ disVal==true ?"disabled":""}>
            <a onClick={e => this.props.addCustomComponent(this.props.const_var.walkInitialValue,'Walk','') }>
            <label>
            <span className="dw-icon">
           <span class="icon-walk-in-doors"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span></span>
            </span>
            <span className="dw-title">
            Walk-in Door
            </span>
            </label>
            <span className="dw-add-icon">
            <span className="icon-plus mr-1"></span>
            Add
            </span>
            </a>
         </li>
         <li className={ disVal==true ?"disabled mr-0":"mr-0"}>
            <a onClick={e => this.props.addCustomComponent(this.props.const_var.windowsInitialValue,'Windows','') }>
            <label>
            <span className="dw-icon">
            <span className="icon-windows"></span>
            </span>
            <span className="dw-title">
            Window
            </span>
            </label>
            <span className="dw-add-icon">
            <span className="icon-plus mr-1"></span>
            Add
            </span>
            </a>
         </li>
         <li className={ SepdisVal==true ?"disabled":""}>
            <a onClick={e => this.props.addCustomComponent(this.props.const_var.customFrameoutInitialSize,'CustomFrameout','') }>
            <label>
            <span className="dw-icon">
            <span className="icon-custom-framed-openings"></span>
            </span>
            <span className="dw-title">
            Framed Openings
            </span>
            </label>
            <span className="dw-add-icon">
            <span className="icon-plus mr-1"></span>
            Add
            </span>
            </a>
         </li>
         <li className={ disVal==true ?"disabled":""}>
            <a onClick={e => this.props.addCustomComponent(this.props.const_var.walkFrameoutInitialValue,'WalkFrameout','') }>
            <label>
            <span className="dw-icon">
            <span className="icon-windows-frame-outs"></span>
            </span>
            <span className="dw-title">
            Walk-in Door<br/>Frame-out
            </span>
            </label>
            <span className="dw-add-icon">
            <span className="icon-plus mr-1"></span>
            Add
            </span>
            </a>
         </li>
         <li  className={ disVal==true ?"disabled mr-0":"mr-0"}>
            <a onClick={e => this.props.addCustomComponent(this.props.const_var.windowsFrameoutInitialValue,'WindowsFrameout','') }>
            <label>
            <span className="dw-icon">
            <span className="icon-windows-frame-outs"></span>
            </span>
            <span className="dw-title">
            Window<br/> Frame-out
            </span>
            </label>
            <span className="dw-add-icon">
            <span className="icon-plus mr-1"></span>
            Add
            </span>
            </a>
         </li>
      </ul>
   </div>
</div>
  <DoorWindowTextBottom/>
</div>

      );


  }
}
const mapStateToProps = (state) => {
  return {...state.reducer,...state.eventReducer}
}
   
   
   export default connect(
   mapStateToProps,
   actionCreator
   )(RightDoorWindow);
